import { Box, css } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import ReactPanZoom from 'react-image-pan-zoom-rotate';

import { useSessionStore } from 'session/useSessionStore';
import { useDownloadImage } from './api/useFileManagerController';

const containerStyle = css({
    display: 'flex',
    backgroundColor: 'rgb(127, 127, 127)',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    '& div > div': {
        top: '50px !important',
    }
});

export function SeismicImageContent({ title, iframe }: Props) {

    const [fileManagerHost, projectToken] = useSessionStore(state => [state.tenantConfiguration?.endpoints.fileManager, state.tenantConfiguration?.tenantToken]);

    const { data: image } = useDownloadImage(iframe);

    const [ imageUrl, setImageUrl ] = useState<string>();

    useEffect(() => {
        if (!image) {
            return;
        }

        const fileReader = new FileReader();
        fileReader.onloadend = () => {
            setImageUrl(fileReader.result as string);
        };
        fileReader.readAsDataURL(image);
    }, [image]);

    return (
        <Fragment>
            <Box css={containerStyle}>

                {
                    !!imageUrl
                    &&
                    <ReactPanZoom
                        image={imageUrl}
                        alt={title}
                    />
                }
            </Box>
        </Fragment>
    );
}

interface Props {
    title: string;
    iframe: string;
}